import * as React from 'react';
import {FormattedMessage} from '@meiko/react-intl';
import {useForm} from 'react-hook-form';
import services from 'services';
import {updateListItem} from 'modules/lists/io';
import useNotifications from 'hooks/useNotifications';
import {useQueryClient} from '@tanstack/react-query';
import {invalidateNextListItemQueries} from 'data/listItem/cache';

import TextArea from 'components/generic/TextArea';
import Button from 'components/generic/Button';
import Panel from './Panel';

let intl = null;
services.waitFor('intl').then(x => (intl = x));

export default function CommentsPanel({listItem, saveCallback}) {
	const {handleSubmit, register, formState} = useForm({
		defaultValues: {
			comment: listItem?.comments || '',
		},
	});

	const {openNotification} = useNotifications();
	const queryClient = useQueryClient();

	const onSubmit = async values => {
		try {
			await updateListItem(listItem.id, {
				comments: values.comment,
			});
			// Keep overlay "next item" in sync if it's open.
			// We don't always have listId in this modal context, so invalidate all nextListItem queries.
			invalidateNextListItemQueries(queryClient);
			saveCallback?.();
			openNotification({
				message: intl.formatMessage({id: 'Saved'}),
				type: 'success',
				duration: 3000,
			});
		} catch (err) {
			openNotification({
				message: intl.formatMessage({id: 'Unexpected error'}),
				type: 'error',
				duration: 3000,
			});
		}
	};

	return (
		<Panel title={<FormattedMessage id="Comment" />}>
			<form className="space-y-2 p-6" onSubmit={handleSubmit(onSubmit)}>
				<TextArea
					className="w-full"
					{...register('comment', {required: true})}
					isValid={!formState.errors.comment}
				/>
				<Button type="submit" appearance={'success'} disabled={formState.isSubmitting}>
					<FormattedMessage id="Save" />
				</Button>
			</form>
		</Panel>
	);
}
